import styled from '@emotion/styled';

export const PillSwitcherWrapper = styled.div`
  ${({ theme }) => `
    display: inline-flex;
    align-items: center;
    padding: 3px;
    gap: ${theme.spacing(0.5)};
    background-color: ${theme.colors.neutrals.white};
    border: 1px solid ${theme.colors.neutrals.grey6};
    border-radius: ${theme.borderRadius.smallestSideRound};
  `}
`;

export const PillSwitcherItem = styled.button<{ isActive: boolean }>`
  ${({ theme, isActive }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    border: 0;
    cursor: pointer;
    border-radius: ${theme.borderRadius.round};
    background-color: ${isActive ? theme.colors.neutrals.grey8 : theme.colors.neutrals.white};
  `}

  svg {
    display: block;
    width: 24px;
    height: 24px;
  }
`;
